module.exports = __webpack_public_path__ + "static/Terra.do-23ec8a52d4a633fa471e3e9be58af942.jpg";